
define('modules/application/wizard/steps/systemChoices/thermoSystemChoices',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../systemChoices",
  "../../../popup"
],

function(app, Backbone, jQueryUi, systemChoices, Popup) {

  //Defining child content view
  var thermoSystemChoices;
  var thermoSystemChoicesContentView      = systemChoices.Views.Content.extend({
    addValidationHandlers   :  function() {
      var that = this;

      //Bind on main control unit selection
      this.options.stepEventAggregator.unbind('mainControlUnit:chosen');
      this.options.stepEventAggregator.bind('mainControlUnit:chosen', function(mainControlUnitId)  {
        that.model.set("mainControlUnitId", mainControlUnitId);
        if (that.isValid())
          this.trigger("step:validated", that.model);
        else
        {
          that.showUnvalidationAlert();
          this.trigger("step:unvalidated", that.model);
        }
      });

      //Bind on main control unit removal
      this.options.stepEventAggregator.unbind('mainControlUnit:removed');
      this.options.stepEventAggregator.bind('mainControlUnit:removed', function()      {
        that.model.set("mainControlUnitId", undefined);
        that.mainControlUnitId=undefined;
        this.trigger("step:unvalidated", that.model);
      });
    }
  });

  //Creating final thermoSystemChoices class
  thermoSystemChoices = _.extend({}, systemChoices, {
    objClass    : "thermoSystemChoices",
    Views       : {
      Content  : thermoSystemChoicesContentView,
      Tab      : systemChoices.Views.Tab.extend()
    }
  });

  // Required, return the module for AMD compliance
  return thermoSystemChoices;

});